import { useTranslation } from "react-i18next";
import { SmallModal } from "../../SmallModal";
import { useForm } from "react-hook-form";
import { CheckIcon } from "@heroicons/react/24/outline";
import { ReactiveFormSelect } from "../../form/ReactiveFormSelect";
import { toast, ToastContainer } from "react-toastify";

interface Props {
    info: {
        show: boolean;
        agencyMailTypes?: any;
    };
    onClose: () => void;
    onSubmited: (SelectedType: any) => void
}

export const SentMailSelectTypeModal: React.FC<Props> = ({
    info,
    onSubmited,
    onClose
}) => {
    const { t } = useTranslation();

    const methods = useForm<any>({
            defaultValues: {}
    })
    const { handleSubmit, control, reset } = methods;

    const onSubmit = (data: any) => {
        if(data.type) {
            onSubmited(data.type);
            closeModal();
        } else {
            toast(t("PLEASE_SELECT_A_MAIL_TYPE"));
        }
    }
    
    const closeModal = () => {
        reset({});
        onClose();
    };

    return (<>
        <SmallModal
            isOpen={info.show}
            onClose={closeModal}
            label={t("MAIL_TYPE")}
            saveButton={{
                label: t("SELECT"),
                icon: <CheckIcon />,
                onClick: handleSubmit(onSubmit),
            }}
        >
            <div className="w-full pt-3 pb-5">
                <div className={"w-full px-3"}>
                    <ReactiveFormSelect
                        width="md:w-1/1"
                        name={`type`}
                        label={t("MAIL_TYPE")}
                        options={info.agencyMailTypes}
                        control={control}
                    />
                    <label className="text-gray-600 text-xs mb-5">
                        {t("MAIL_TYPE_MESSAGE")}
                    </label>
                </div>
            </div>
        </SmallModal>
        <ToastContainer progressStyle={{ background: "#D4AF37" }} />
    </>)
}